import { render, staticRenderFns } from "./CopyShareDialog.vue?vue&type=template&id=4c3ba1a4&"
import script from "./CopyShareDialog.vue?vue&type=script&lang=js&"
export * from "./CopyShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./CopyShareDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports